import React , {useState, useEffect} from "react";
import axios from "axios";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import * as Common from "../../Common/common.js";

import mainBg from "../../assets/img/bg-company-02.jpg";

function ComHisPubList() {

    // 일반 또는 관리자 header 설정
    const { argInfo } = useContext(ArgContext);
    const isAdmin = argInfo?.role === 'admin';

    // 권한 체크
    const authCk = Common.fn_authChek();

    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

    // 연혁 리스트 data
    const [comYearList, setComYearList] = useState([]);
    let index = 1;

    // 최초로딩시 한번
    useEffect(() => {
        // 회사 연혁 조회
        fn_selectAdminYearList();
    }, []);

    // 최초로딩시 한번
    useEffect(() => {
    }, [comYearList]);

    // 회사 연혁 조회하기
    const fn_selectAdminYearList = async () => {
        await axios.post("/selectYearList")
        .then((response) => {
            //console.log(response.data.rtnData)
            setComYearList(response.data.rtnData);
        })
        .catch((error) => {
        // 예외 처리
        })
    }

    

    return (
        <>
    <main className="page-wrapper">
    {isAdmin ? <AdminHeader /> : <Header />}
            {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>회사연혁</h2>
						<p>위피아는 끊임없는 도전을 통해 미래가치를 창출합니다.</p>
					</div>
                    <SubMenu />
			</section>
	    
            
			 

            <section className="container-auto comHisPubList tab-pane fade show active"  role="tabpanel">
                <ul className="tabWrap tab-3" role="tablist">
                    <li><a className="nav-link active" href="#history1" data-bs-toggle="tab" role="tab">2021 ~ 현재</a></li>
                    <li><a className="nav-link" href="#history2" data-bs-toggle="tab" role="tab" >2011~2020</a></li>
                    <li><a className="nav-link" href="#history3" data-bs-toggle="tab" role="tab" >2004~2010</a></li>
                </ul>
                
                <div className="comHist-cont">
                    <div className="textBox">
                        <span className="history">HISTORY</span>
                        <h3 className="sub-title">위피아 핵심역량</h3>
                        <p className="sub-text">위피아의 핵심역량은 Creative한 사업기획력과 뛰어난 IT 기술력을 보유한 우수한 인력들 입니다.</p>
                    </div>
                    <div className="cont-wrap">
                        {/* <!-- 2021~현재 --> */}
                        <ul className="tabCont tab-pane fade show active" id="history1" role="tabpanel">
                            {/*
                            <div class="history-wrap-current">
                                <div class="history-year-area"><span class="blue">2025</span></div>
                                <div class="history-month-area">
                                    <ul class="history-month-list">
                                        <li class="history-month-item">
                                            <div class="history-month-title">1월</div>
                                            <div class="history-month-detail"><div class="history-month-desc-box">
                                                <p class="history-month-desc">국립해양측위정보원 2025년 해로드 앱 유지관리</p>
                                            </div>
                                            <div class="history-month-desc-box"><p class="history-month-desc">전세 셔틀버스 시스템 유지관리</p>
                                            </div>
                                            <div class="history-month-desc-box"><p class="history-month-desc">현대오토에버 동반성장 협약 체결</p></div>
                                            <div class="history-month-desc-box"><p class="history-month-desc">두산 밥캣 LINQ LIB Monitoring Web/App 운영</p></div>
                                            <div class="history-month-desc-box"><p class="history-month-desc">SK- ERS 시스템 사고약도 솔루션 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">GS칼텍스 2025년도 차량관제 시스템 및 전자지도 유지보수</p></div>
                                            <div class="history-month-desc-box"><p class="history-month-desc">2025년 서울시 개인형 이동장치(PM) 신고시스템 운영 및 유지관리</p></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="history-wrap">
                                <div class="history-year-area"><span class="blue">2024</span></div>
                                <div class="history-month-area">
                                    <ul class="history-month-list">
                                        <li class="history-month-item">
                                            <div class="history-month-title">12월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">현대건설 ICT  건설관리 플랫폼 구축</p></div><div class="history-month-desc-box"><p class="history-month-desc">현대자동차 신규 글로벌 보증 시스템 통합 개편(2단계)</p></div></div>
                                        </li>
                                        <li class="history-month-item"><div class="history-month-title">11월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">고향사랑e음 디지털서비스 개방 API 개발</p></div></div></li>
                                        <li class="history-month-item"><div class="history-month-title">9월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">TTA  AI기반 표준 내비게이터  구축(장기계속3년차)</p></div></div></li>
                                        <li class="history-month-item"><div class="history-month-title">7월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">두산 밥캣 LINQ LIB Monitoring Web/App 운영</p></div></div></li>
                                        <li class="history-month-item"><div class="history-month-title">6월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">국립해양측위정보원 2024년 해로드 앱 기능개선</p></div></div></li>
                                        <li class="history-month-item"><div class="history-month-title">3월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">
현대자동차 신규 글로벌 보증 시스템 통합 개편 (1단계)</p></div><div class="history-month-desc-box"><p class="history-month-desc">레드캡투어 기업출장 모바일 앱 개선 개발</p></div><div class="history-month-desc-box"><p class="history-month-desc">ESG 우수 중소기업 선정</p></div><div class="history-month-desc-box"><p class="history-month-desc">벤처기업확인(연구개발유형)</p></div></div></li>
<li class="history-month-item"><div class="history-month-title">1월</div><div class="history-month-detail"><div class="history-month-desc-box"><p class="history-month-desc">한일고속페리 예발매시스템 운영.유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">GS칼텍스 2024년도 차량관제 시스템 및 전자지도 유지보수</p></div><div class="history-month-desc-box"><p class="history-month-desc">현대오토에버 동반성장 협약 체결</p></div><div class="history-month-desc-box"><p class="history-month-desc">두산 밥캣 MH 텔레매택스서비스(LINQ) Web, App 구축</p></div><div class="history-month-desc-box"><p class="history-month-desc">SK네트웍스  ERS 시스템 사고약도 솔루션 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">2024년 고향사랑 e음 종합정보시스템 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">2024년 서울시 개인형 이동장치(PM) 신고시스템 운영 및 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">국립해양측위정보원 2024년 해로드 앱 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">금호고속 전세 셔틀버스 시스템 유지관리</p></div><div class="history-month-desc-box"><p class="history-month-desc">현대모비스 엠브레인 서비스플랫폼 구축</p></div></div></li>
                                    </ul>
                                </div>
                            </div>
                     
                            */}
                            {
                                comYearList.map((yearList, index) => {
                                    if(yearList.year > '2020')
                                    return (<NewYear 
                                        topIndex = {index}
                                        year={yearList.year} 
                                        monthList={yearList.monthList} 
                                        key={index + "-" + yearList.year}
                                    /> )
                                })

                            }
                        </ul>
                        
                        {/* <!-- 2011~2020 --> */}
                        <ul className="tabCont tab-pane fade" id="history2" role="tabpane2">
                        {
                            comYearList.map((yearList, index) => {
                                if(yearList.year > '2010' && yearList.year <= '2020')
                                return (<NewYear 
                                    topIndex = {index}
                                    year={yearList.year} 
                                    monthList={yearList.monthList} 
                                    key={index + "-" + yearList.year}
                                /> )
                            })
                        }
                        </ul>

                        {/* <!-- 2004~2010 --> */}
                        <ul className="tabCont tab-pane fade" id="history3" role="tabpane3">
                            {
                                comYearList.map((yearList, index) => {
                                    if(yearList.year <= '2010')
                                    return (<NewYear 
                                        topIndex = {index}
                                        year={yearList.year} 
                                        monthList={yearList.monthList} 
                                        key={index + "-" + yearList.year}
                                    /> )
                                })

                            }
                        </ul>

                    </div>
                </div>
                
                

            </section>
        </main>
    <Footer />
        </>
    )
}

function NewTask(props){

    return (
        <div key={props.index} className="history-month-desc-box"> 
			<p className="history-month-desc">{props.task}</p> 
		</div> 
    );
}

function NewMonth(props){

    return (
        <li key={props.index} className="history-month-item"> 
            <div className="history-month-title">{props.month}월</div> 
            <div className="history-month-detail"> 
                {props.rowList.map((row, index) => {
                    return <NewTask index={index} task={row.taskContent} key={index + "-" + props.month}/>
                })}
             
            </div>
        </li> 
    );

}

function NewYear(props){
    
    return (
        <div key={props.topIndex} className={props.topIndex == 0 ? 'history-wrap-current' : 'history-wrap'}> 
			<div className="history-year-area"><span className="blue">{props.year}</span></div> 
			<div className="history-month-area"> 
				<ul className="history-month-list"> 
					{props.monthList.map((month, index) => {
                        
                        return(
                            <NewMonth index={index}
                                month={month.month}
                                rowList={month.rowList}
                                key={props.year + "-" + month.month}
                            />
                        );
                    })

                    }
				</ul> 
			</div> 
		</div>

    );
}

export default ComHisPubList;